module.exports = __webpack_public_path__ + "static/media/zertifiziert_ergopraxis_soest_baumheier.3c66d2cf.jpg";